import { create } from "zustand";

const initialState = {
  avatarDataUri: null,
  isLoading: false,
};

const useCustomerProfileStore = create((set) => ({
  ...initialState,
  setAvatarDataUri: (payload) => {
    set({ avatarDataUri: payload });
  },
  setAvatarIsLoading: (payload) => {
    set({ isLoading: payload });
  },
}));

export default useCustomerProfileStore;
